import { createFileRoute } from '@tanstack/react-router';
import { SignoffScreen } from '@/components/discovery/signoff/signoff-screen';

/**
 * Discovery -> Sign-off (T-0191, E12-F11). Opened from the Overview card and
 * from the Selection -> Requirements header (Decision 54.40), not a tab.
 */
export const Route = createFileRoute('/engagements/$engagementId/discovery/signoff')({
  component: SignoffRoute,
});

function SignoffRoute() {
  const { engagementId } = Route.useParams();
  return <SignoffScreen engagementId={engagementId} />;
}
